import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KreditorService } from '../shared/kreditor.service';
import { IStatusGroup } from '../shared/models';

@Injectable({
  providedIn: 'root'
})
export class StatusesService {

  constructor(private kreditorWs: KreditorService) { }

  getStatusGroups() : Observable<IStatusGroup[]> {
    return this.kreditorWs.getServiceResult<IStatusGroup[]>("statuses/groups").pipe(map(_ => _.result));
  }
}
